<template>
  <div>
    <el-row>
      <el-col :span="8">
        <form-item
          :label="$t('CampaignForm_Events_Delay_Qualification_Event')"
          style="margin-bottom: 20px"
        >
          <el-autocomplete
            :placeholder="$t('CampaignForm_Select_Event')"
            clearable
            v-model="model.qualification_event_title"
            :fetch-suggestions="querySearchEvents"
            :select-when-unmatched="true"
            style="width: 100%"
          />
        </form-item>
      </el-col>
      <el-col :span="8" style="padding-top: 40px">
        <toggle
          v-model="model.qualification_event_filter"
          :text="$t('CampaignForm_Select_Event_Filter')"
        />
      </el-col>
    </el-row>

    <el-row v-if="model.qualification_event_filter">
      <el-col :span="24">
        <form-item style="margin-bottom: 20px">
          <conditions-editor
            ref="qualification-event-conditions-editor"
            v-model="model.qualification_event_conditions"
            data-model-name="Campaign"
            data-model-attribute="qualification_event_conditions"
            attribute-list-data-url="/push/event-filter/attribute-list-data"
            :preview="false"
            :no-data-alert="false"
            :single-level="true"
          />
        </form-item>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="8">
        <form-item
          :label="$t('CampaignForm_Events_Delay_Qualification_Interval')"
        >
          <div style="display: flex">
            <el-input-number
              class="delay-input-number"
              v-model="model.qualification_time"
              style="margin-right: 10px"
              :controls="false"
              :min="0"
              :max="1000"
            />

            <el-select
              class="delay-input-period"
              v-model="model.qualification_period"
            >
              <el-option
                value="minutes"
                :label="$t('CampaignForm_Events_Delay_Minutes')"
              />
              <el-option
                value="hours"
                :label="$t('CampaignForm_Events_Delay_Hours')"
              />
              <el-option
                value="days"
                :label="$t('CampaignForm_Events_Delay_Days')"
              />
            </el-select>
          </div>
        </form-item>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import RestApi from '@/core/services/RestApi'
import ConditionsEditor from '@/common/components/ConditionsEditor.vue'
import Toggle from '@/common/components/form/Toggle.vue'
import FormItem from '@/common/components/form/FormItem.vue'
import { projectEndpoint } from '@/core/helpers'

export default {
  name: 'QualificationTrigger',

  components: {
    FormItem,
    Toggle,
    ConditionsEditor
  },

  props: {
    model: {
      type: Object
    }
  },

  methods: {
    querySearchEvents(queryString, cb) {
      const params = {
        sort: 'title'
      }

      if (queryString !== null && queryString !== '') {
        params.title = queryString
      }

      RestApi(
        projectEndpoint({
          method: 'get',
          url: 'events',
          params: params
        })
      ).then(({ data }) => {
        const list = data.map(event => {
          return {
            value: event.title,
            type: event.type
          }
        })
        cb(list)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/events/QualificationTrigger.vue